// agent-postpone.model.ts

export class AgentPostponeDto {
    RequestId: string;
    agentTransitDate: Date; // or string, depending on your setup
    agentETA: Date;   // or string
    RequestorId: string;
    Direction: number;

}